import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import MUITypography from '../../../Components/MUITypography';
import { SESSION_USER_COUNTRY_DATA_KEY, SESSION_USER_ID_KEY, SESSION_USER_ROLES_PERMISSIONS } from '../../../Util/VMConstants';
import { align_column, align_left, VM_Colors, vmActionButtonSx } from '../../../Styles/VMStyles';
import { checkIsPermissionExist, displayFormattedDateTime, formatAmount } from '../../../Util/UtilHelper';
import { canMutateRecord } from '../../../Util/recordAuthorization';
import InvoiceTemplateDrawer from '../Invoice/InvoiceTemplateDrawer';
import StorageFactory from '../../../Util/StorageFactory';
import UpdatePaymentDrawer from '../Invoice/UpdatePaymentDrawer';
import { API_DISPLAY_INVOICE } from '../../../Util/URLConstants';

function InvoicePlaceholder({ invoice_info, refreshEnquiryDetails, readOnly = false }) {
  const [state, setState] = useState({
    templateDrawerOpen: false,
    updatepaymentDrawerOpen: false,
  });

  if (!invoice_info || invoice_info.length === 0) return null;

  const { name, invoice_id, enquiry_id, pending_amount, paid_amount, payment_mode, is_invoice_clear, final_payable_amount, created_date,created_by } = invoice_info[0] || {};

  const sessionFactory = new StorageFactory('session');
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);
  const VM_PERMISSIONS = sessionFactory.get(SESSION_USER_ROLES_PERMISSIONS);
  const currencySymbol = sessionFactory.get(SESSION_USER_COUNTRY_DATA_KEY)?.currency_symbol || '₹';

  const invoiceUrl = API_DISPLAY_INVOICE + `?enquiry_id=${enquiry_id}&user_id=${userID}` + '&template_id=1';

const infoItems = [
  { key: 'invoice', label: 'Invoice Number', value: invoice_id },
  { key: 'created', label: 'Created On', value: displayFormattedDateTime(created_date,currencySymbol) },
  { key: 'amount', label: 'Total Amount', value: formatAmount(final_payable_amount, currencySymbol) },
  { key: 'status', label: 'Status', value: is_invoice_clear ? 'Payment Cleared' : 'Payment Not Cleared' },
  { key: 'pending', label: 'Pending Amount', value: formatAmount(pending_amount, currencySymbol) },
  { key: 'paid', label: 'Amount Paid', value: formatAmount(paid_amount, currencySymbol) },
  { key: 'created_by', label: 'Created By', value: created_by?.name
    ? [created_by.name, created_by.user_type || created_by.userType].filter(Boolean).join(' ')
    : '-' },
  
  ...(!is_invoice_clear ? [
    // { key: 'method', label: 'Payment Method', value: payment_mode }
  ] : []),
];


  // const handleDownload = async () => {
  //   try {
  //     const invoiceUrl = `${API_DISPLAY_INVOICE}?enquiry_id=${enquiry_id}&user_id=${userID}&template_id=1`;
  //     const response = await axios.get(invoiceUrl, { responseType: 'blob' });
  //     const filename = `${enquiry_id}.pdf`;
  //     FileSaver.saveAs(response.data, filename);
  //   } catch (error) {
  //     console.error('Failed to download invoice:', error);
  //   }
  // };

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: 'Invoice', text: 'Here is your invoice', url: invoiceUrl });
      } else {
        await navigator.clipboard.writeText(invoiceUrl);
        alert('Invoice link copied to clipboard!');
      }
    } catch (err) {
      console.error('Error sharing invoice:', err);
    }
  };

  const commonBtnStyle = vmActionButtonSx;

  return (
    <Box sx={{ width: '100%', maxWidth: 860, backgroundColor: '#fff',ml:1 }}>
      {/* Header */}
      <Box sx={{ mb: 2 }}>
        <MUITypography variant="h4" gutterBottom sx={{ fontWeight: 700, color: '#1E1E1E' }}>
          Added Invoice
        </MUITypography>
      </Box>

      {/* Info Box - using CSS Grid so Status can span 2 columns */}
      <Box
        sx={{
          pl: 1,pr:1,ml:2,mr:2,
          borderRadius: 2,
          backgroundColor: '#EFF3FF',
          display: 'grid',
          gap: 1,
          // responsive columns: 1 on xs, 2 on sm, 4 on md+
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(4, 1fr)',
          },
          alignItems: 'start',
        }}
      >
        {infoItems.map((item) => {
          const isStatus = item.key === 'status';
          return (
            <Box
              key={item.key}
              sx={{
                ...align_column,
                p: 1,
                minWidth: 100,
                borderRadius: 1,
                // gridColumn: isStatus ? { xs: 'auto', sm: 'auto', md: 'span 2' } : 'auto',
              }}
            >
              <MUITypography sx={{ fontSize: 14, color: '#6C6C6C', mb: 0.5 }}>{item.label}</MUITypography>

              {isStatus ? (
                <Box
                  sx={{
                    p: 1,
                    borderRadius: 1,
                    fontWeight: 600,
                    bgcolor: VM_Colors.white,
                    color: is_invoice_clear === true ? VM_Colors.success : VM_Colors.error,
                    boxShadow: 2,
                    ...align_left,
                    // alignSelf: 'center',
                  }}
                >
                  <MUITypography sx={{ fontSize: 13 }}>
                    {is_invoice_clear === true ? '✔  Payment Cleared' : '❌  Payment Pending'}
                  </MUITypography>
                </Box>
              ) : (
                <MUITypography sx={{ fontWeight: 600, fontSize: 16, color: '#000' }}>{item.value || '-'}</MUITypography>
              )}
            </Box>
          );
        })}
      </Box>

      {/* Action Buttons */}
      <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        {!readOnly && canMutateRecord(VM_PERMISSIONS, 'VM007', invoice_info[0]) && (
          <Button
            variant="contained"
            color="primary"
            sx={commonBtnStyle}
            onClick={() => setState((prev) => ({ ...prev, updatepaymentDrawerOpen: true }))}
          >
            Update payment
          </Button>
        )}

        {checkIsPermissionExist(VM_PERMISSIONS, 'VM006') && (
          <Button
            variant="contained"
            sx={{ ...commonBtnStyle, backgroundColor: VM_Colors.success, color: '#fff' }}
            onClick={() => setState((prev) => ({ ...prev, templateDrawerOpen: true }))}
          >
            View Invoice
          </Button>
        )}

        {/* <Button variant="contained" sx={{ ...commonBtnStyle, backgroundColor: '#FF8C00', color: '#fff' }} onClick={handleDownload}>
          Download
        </Button> */}

        {/* <Button variant="outlined" sx={{ ...commonBtnStyle, borderColor: '#1E3A8A', color: '#1E3A8A' }} onClick={handleShare}>
          Share
        </Button> */}
      </Box>

      {/* Drawers */}
      <InvoiceTemplateDrawer open={state.templateDrawerOpen} onClose={() => setState({ ...state, templateDrawerOpen: false })} enquiry_id={enquiry_id} user_id={userID} name={name}/>
      <UpdatePaymentDrawer
        open={state.updatepaymentDrawerOpen}
        onClose={() => {
          setState({ ...state, updatepaymentDrawerOpen: false });
          refreshEnquiryDetails();
        }}
        enquiry_id={enquiry_id}
        user_id={userID}
        invoice_id={invoice_id}
      />
    </Box>
  );
}

export default InvoicePlaceholder;
